import type { ComponentProps } from 'react';

import { cn } from '../cn';

export type ImageViewerProps = ComponentProps<'div'> & {
  src: string;
  alt?: string;
};

export function ImageViewer({ src, alt = 'Attachment', className }: ImageViewerProps) {
  return (
    <div className={cn('overflow-hidden rounded-tr-lg', className)}>
      <a href={src} target="_blank" rel="noopener noreferrer" className="block">
        <img
          src={src}
          alt={alt}
          className="max-h-64 max-w-full cursor-pointer bg-[#4A5678] object-contain transition-opacity hover:opacity-90"
        />
      </a>
    </div>
  );
}
